import { useState } from 'react';

import { ScrollArea } from 'components/ui/scroll-area';
import BasicDetails from './basic-details';
import Loader from 'components/Loader';
import ProfileDetails from 'components/ProfileDetail';
import UserProfile from 'components/UserProfile';
import Questionnaire from './questionnaire';

export default function ProfilePage() {
  const [isDetailLoading, setIsDetailLoading] = useState<boolean>(false);

  return (
    <div className='grid grid-cols-1 md:grid-cols-12 xl:grid-cols-7 gap-x-6'>
      <ScrollArea className='col-span-1 md:col-span-5 xl:col-span-2 bg-[#0E2439] p-4 h-fit sm:h-[calc(100vh-3.5rem)] lg:h-screen sm:border-t border-gray-500 lg:border-t-0'>
        {isDetailLoading ? (
          <Loader className='h-screen' />
        ) : (
          <>
            <div
              className='relative flex flex-col max-w-sm p-2 mx-auto lg:hidden h-fit rounded-xl'
              style={{
                background:
                  'linear-gradient(174.13deg, rgba(255, 255, 255, 0.18) 1.16%, rgba(255, 255, 255, 0.054) 54.02%, rgba(255, 255, 255, 0.130005) 97.27%)',
              }}
            >
              <ProfileDetails className='mt-8 sm:mt-20' />
              <BasicDetails setLoading={setIsDetailLoading} />
            </div>

            <div className='hidden lg:block'>
              <UserProfile>
                <ProfileDetails className='mt-8 sm:mt-10' />
                <BasicDetails setLoading={setIsDetailLoading} />
              </UserProfile>
            </div>
          </>
        )}
      </ScrollArea>

      <div className='col-span-1 md:col-span-7 xl:col-span-5'>
        <Questionnaire />
      </div>
    </div>
  );
}
